var _circle, _path, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongRenyuan11(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    transform: "rotate(-180 8 8)",
    stroke: "#3F465C",
    r: 6.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.556 12.409l-.5.016.5-.016zm-.5.016l.007.19 1-.032-.007-.19-1 .032zM6.374 10.25h3.435v-1H6.373v1zm6.683 2.143A3.25 3.25 0 009.808 9.25v1a2.25 2.25 0 012.249 2.175l1-.033zm-8.931.19a2.258 2.258 0 012.248-2.333v-1a3.258 3.258 0 00-3.247 3.367l.999-.033z",
    fill: "#3F465C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 6.175,
    r: 2.234,
    stroke: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_renyuan11.b7328125.svg";
export { SvgTongyongRenyuan11 as ReactComponent };